import servicesUtils from "../../../utils/servicesUtils";
var getPatientTags = function getPatientTags(patientUid) {
  return servicesUtils.getService("/patients/".concat(patientUid, "/tags/"));
};
export default getPatientTags;